import { MINIMAL_INVOICE_NUMBER } from '../../constants/minimalInvoiceNumber'
import { InvoiceForm } from '../../types/invoiceForm/invoiceForm'
import { InvoicePayloadInvoiceNumber } from '../../types/invoicePayload/invoicePayLoadNumber'

export const getInvoiceNumberPayload = (formValues: InvoiceForm): InvoicePayloadInvoiceNumber => {
  const invoiceNumberPayload: InvoicePayloadInvoiceNumber = { number: MINIMAL_INVOICE_NUMBER, prefix: null }

  if (formValues.invoiceNumber !== undefined) {
    invoiceNumberPayload.number = formValues.invoiceNumber
  }

  if (formValues.invoiceNumberPrefix !== undefined) {
    invoiceNumberPayload.prefix = formValues.invoiceNumberPrefix
  }

  return invoiceNumberPayload
}
